// extracted by mini-css-extract-plugin
module.exports = {"container":"post_container__1hOHH","title":"post_title__10ecw","content":"post_content__R3Fzh"};